import React from 'react';
import { LoadingView } from '../../../../motion/Loading';

// Раньше — белый экран поверх всего приложения (вместе с шапкой) и кольцевой спиннер.
// Теперь загрузка встаёт на место содержимого и не закрывает шапку и меню:
//   variant="list"    — скелет списка заданий,
//   variant="task"    — скелет экрана задания,
//   variant="overlay" — полупрозрачная пелена под шапкой поверх показанного экрана,
//   по умолчанию      — индикатор по центру области контента.
// style.top (старый способ сдвинуть спиннер ниже) переводится в отступ сверху.
const Loader = ({ style, variant, count, inset }) => {
    const offsetTop = style && style.top ? style.top : undefined;
    return <LoadingView variant={variant} count={count} inset={inset} offsetTop={offsetTop} />;
};

export default Loader;
